import { gql } from 'apollo-boost';

export const SYSTEM_CHAT_USER_FRAGMENT = gql`
  fragment systemChatUserKeys on Conversation {
    user {
      id
      name
      verification_status
      deleted
      email
      legal_name
      phone_number
      first_image {
        id
        thumb
        medium
        is_verified
        rejection_text
      }
      images {
        id
        thumb
        medium
        is_verified
        rejection_text
      }
      suspended
    }
  }
`;
